import React from 'react';
import { Row, Col, Table } from 'reactstrap';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import CompanyStatusButtons from './companyStatusButtons';

const Companies = ({ companies, refresh }) => {
  const history = useHistory();

  const viewTenantDetails = (id) => {
    history.push(`/overview/${id}`);
  };

  return (
    <div>
      <Row>
        <Col>
          <div className="content-heading">
            <div>
              Companies
              <small>List of companies which are using the solution.</small>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <Table striped bordered style={{ minWidth: '800px' }}>
              <thead>
                <tr>
                  <th></th>
                  <th>Id</th>
                  <th>Name</th>
                  <th>Website</th>
                  <th>Created</th>
                  <th>Modified</th>
                  <th>Tenant</th>
                  <th>Status</th>
                  <th>Tenant Id</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {companies.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.website}</td>
                    <td>{moment.utc(item.created).local().format('ll')}</td>
                    <td>{moment.utc(item.modified).local().fromNow()}</td>
                    <td>{item.tenantName}</td>
                    <td>
                      <CompanyStatusButtons company={item} refresh={() => refresh()} />
                    </td>
                    <td>{item.tenantId}</td>
                    <td>
                      <em
                        id={`eyeButton-${index}`}
                        style={{ cursor: 'pointer' }}
                        className="fa-2x mr-2 fas fa-eye"
                        onClick={() => viewTenantDetails(item.tenantId)}
                      ></em>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Companies;
